import { Component } from '@angular/core';
import { LanguageService } from './i18n/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(private languageService: LanguageService) {}
}
